<app-page-title
  [heading]="heading"
  [subheading]="subheading"
  [icon]="icon"
  [menuConfiguration]="headerMenuConfiguration"
>
</app-page-title>
<div
  *ngIf="
    !usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesList')
  "
>
  You have no rights to access this page
</div>
<div
  *ngIf="
    !!fullAudiences &&
    usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesList')
  "
>
  <mat-tab-group (selectedTabChange)="tabChange($event)">
    <mat-tab label="Active"></mat-tab>
    <mat-tab label="Archived" *ngIf="showArchivedTab"></mat-tab>
  </mat-tab-group>
  <eris-table [dataSource]="audiencesDataSource" #parent>
    <ng-container *ngFor="let audience of parent.data; index as i">
      <tr>
        <th scope="row" class="align-middle" style="width: 5%">
          {{ audience.id }}
        </th>
        <td class="align-middle" style="width: 28%; word-break: break-all">
          <a
            *ngIf="audience?.status == 2"
            class="main-page-link"
            (click)="navigateAudienceDetails(audience)"
            >{{ audience.name }}</a
          >
          <span *ngIf="audience?.status != 2">{{ audience.name }}</span>
        </td>
        <td class="align-middle" style="width: 7%">
          {{ audience.created | date }}
        </td>
        <td class="align-middle" style="width: 7%">
          {{ audience.updated | date }}
        </td>
        <td class="align-middle" style="width: 5%">
          {{ audience.profilesCount | number : "" : "es" }}
        </td>
        <td class="align-middle" style="width: 22%">
          <div>
            <ng-container
              *ngFor="
                let item of getIdentifiersCountsSorted(audience);
                let i = index;
                let last = last
              "
            >
              <div *ngIf="i % 3 == 0" class="row">
                <div class="col-md-1">
                  <img
                    [src]="audiencesService.getIdentifiersTypeSmallIcon(item.key)"
                    [title]="
                      audiencesService.getIdGraphTypeDescription(item.key)
                    "
                    alt="icon"
                    style="width: 32px; height: 32px"
                  />
                </div>
                <div
                  class="col-md-3"
                  style="line-height: 32px; text-align: center"
                >
                  <span>{{ item.value | number : "" : "es" }}</span>
                </div>
                <div class="col-md-1">
                  <img
                    *ngIf="i < getIdentifiersCountsSorted(audience).length - 1"
                    [src]="
                      audiencesService.getIdentifiersTypeSmallIcon(
                        getIdentifiersCountsSorted(audience)[i + 1].key
                      )
                    "
                    alt="icon"
                    style="width: 32px; height: 32px"
                  />
                </div>
                <div
                  class="col-md-3"
                  style="line-height: 32px; text-align: center"
                >
                  <span
                    *ngIf="i < getIdentifiersCountsSorted(audience).length - 1"
                    >{{
                      getIdentifiersCountsSorted(audience)[i + 1].value
                        | number : "" : "es"
                    }}</span
                  >
                </div>
                <div class="col-md-1">
                  <img
                    *ngIf="i < getIdentifiersCountsSorted(audience).length - 2"
                    [src]="
                      audiencesService.getIdentifiersTypeSmallIcon(
                        getIdentifiersCountsSorted(audience)[i + 2].key
                      )
                    "
                    alt="icon"
                    style="width: 32px; height: 32px"
                  />
                </div>
                <div
                  class="col-md-3"
                  style="line-height: 32px; text-align: center"
                >
                  <span
                    *ngIf="i < getIdentifiersCountsSorted(audience).length - 2"
                    >{{
                      getIdentifiersCountsSorted(audience)[i + 2].value
                        | number : "" : "es"
                    }}</span
                  >
                </div>
              </div>
              <div
                *ngIf="
                  i % 3 == 0 &&
                  getIdentifiersCountsSorted(audience).length + (1 % 3) != 0 &&
                  i < getIdentifiersCountsSorted(audience).length - 1
                "
                style="height: 3px"
              ></div>
            </ng-container>
          </div>
        </td>
        <td
          class="align-middle"
          style="width: 4%"
          *ngIf="
            usersService.hasSelectedCompanyActionRight(
              'Audiences',
              'AudiencesList',
              'Manage'
            )
          "
        >
          <div>
            <div
              class="font-icon-wrapper-button"
              (click)="showAudienceDetails(audience)"
              style="
                cursor: pointer;
                display: inline-flex;
                width: 44px;
                height: 44px;
                position: relative;
              "
            >
              <i
                class="fa fa-info-circle"
                aria-hidden="true"
                title="Show audience info"
                style="position: absolute"
              >
              </i>
              <i
                class="fa fa-users"
                aria-hidden="true"
                title="Look-alikes calculated"
                style="
                  font-size: 1.2em;
                  position: absolute;
                  left: 26px;
                  top: -8px;
                  overflow: visible;
                "
                *ngIf="audience.lookAlikeParametersCalculated"
              >
              </i>
              <i
                class="fa fa-comment"
                aria-hidden="true"
                title="Has comments"
                style="
                  font-size: 1.2em;
                  position: absolute;
                  left: -4px;
                  top: 32px;
                  overflow: visible;
                "
                *ngIf="!!audience.tags && audience.comments.length > 0"
              >
              </i>
              <i
                class="fa fa-tags"
                aria-hidden="true"
                title="Has tags"
                style="
                  font-size: 1.2em;
                  position: absolute;
                  left: 28px;
                  top: 32px;
                  overflow: visible;
                "
                *ngIf="!!audience.tags && audience.tags.length > 0"
              >
              </i>
            </div>
          </div>
        </td>
        <td class="align-middle" style="width: 8%">
          <div>
            <div class="font-icon-wrapper">
              <i [class]="getStatusClass(audience)"> </i>
            </div>
            <div
              class="d-flex justify-content-center"
              style="text-align: center"
            >
              {{ getStatusLabel(audience) }}
            </div>
          </div>
        </td>
        <td
          class="align-middle"
          style="width: 4%"
          *ngIf="
            usersService.hasSelectedCompanyActionRight(
              'Audiences',
              'AudiencesList',
              'Manage'
            )
          "
        >
          <eris-menu *ngIf="audience?.status != 10"
            [context]="audience"
            [menuConfiguration]="menuConfiguration"
            [onMenuClosed]="onMenuClosed"
            [onMenuOpened]="stopRefreshPolling"
          ></eris-menu>
          <eris-menu *ngIf="audience?.status == 10"
            [context]="audience"
            [menuConfiguration]="menuConfigurationArchived"
            [onMenuClosed]="onMenuClosed"
            [onMenuOpened]="stopRefreshPolling"
          ></eris-menu>
        </td>
      </tr>
    </ng-container>
  </eris-table>
</div>
